import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Panel } from '../../../../../Components/Panel/Panel';
import { AptorApi } from '../../../../../Api/AptorApi';
import { CreateInformationBoardForm } from './Create.Form';
import Loading from '../../../../../Components/Loading';
import { useOptions } from '.././Options';
import { FormValues } from '../../../../../Components/Form/Form.types';
import { Container, BackButton } from '../../../../../Components';
import { entityToSelectOption } from '../../../../../Utilities';
import { useIntl } from 'react-intl';
import { useAptorApi } from '../../../../../Api';

export const EditInformationBoard = () => {
  const { id } = useParams<{ id: string }>();
  const [options, loading] = useOptions();
  const [announcementData, setAnnouncementData] = useState<any>(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { api } = useAptorApi();

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        if (id) {
          const data = await api.getAnnouncement(parseInt(id));
          setAnnouncementData(data);
        }
      } catch (err) {
        setError('Failed to load announcement');
        console.error(err);
      } finally {
        setDataLoading(false);
      }
    };

    fetchAnnouncement();
  }, [id, api]);

  const handleSubmit = async (form: FormValues, api: AptorApi, onSuccess: () => void) => {
    try {
      if (id) {
        await api.updateAnnouncement(parseInt(id), form);
        onSuccess();
        navigate(`/admin/law-portal/information-board`);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const visible = [
    {
      id: 1,
      name: formatMessage({ id: 'admin.law-portal.informationboard.form.visible.onlyVisibleClintAdmin', defaultMessage: 'Only visible to Client Admin' })
    },
    {
      id: 2,
      name: formatMessage({ id: 'admin.law-portal.informationboard.form.visible.onlyVisibleUser', defaultMessage: 'Only visible to User' })
    },
    {
      id: 3,
      name: formatMessage({ id: 'admin.law-portal.informationboard.form.visible.visibleBoth', defaultMessage: 'Visible to both Client Admin and User' })
    }
  ].map(entityToSelectOption)

  if (loading || dataLoading) {
    return <Loading />;
  }

  if (error) {
    return <Container>{error}</Container>;
  }

  return (
    <Container>
      <BackButton link="/admin/law-portal/information-board" />
      <Panel titleKey="" accordion={false}>
        <CreateInformationBoardForm submit={handleSubmit} visible={visible} initialData={announcementData} />
      </Panel>
    </Container>
  );
};
